import { z } from 'zod'

export const ADMINRUNTIMEPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminRuntimePostResponseSchema = z.unknown()
export type AdminRuntimePostResponse = z.infer<typeof adminRuntimePostResponseSchema>
